/**
 * @file index.tsx
 *
 * @fileoverview Renders the default icon for when an organization has no logo.
 */

import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { OrganizationProfile } from '~/jobiqo/types/types';

interface OrganizationTeaserNoLogoSlotProps {
  /**
   * The organization to render the icon for.
   */
  organization: Slottable<OrganizationProfile>;
}

export default function OrganizationTeaserNoLogoSlot({
  organization,
}: OrganizationTeaserNoLogoSlotProps) {
  return null;
}
export { OrganizationTeaserNoLogoSlot };
